import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getHostHub } from 'owa-config';
import { isCopilotLicensedAndEnabledUser } from './isCopilotLicensedAndEnabledUser';
import { isCopilotStarterSkuAndEnabledUser } from './isCopilotStarterSkuAndEnabledUser';

export function isCalendarEventFormV2Enabled(): boolean {
    const isFormV2EnabledForNonCopilotUsers = isGlobalFeatureEnabled('cal-forms-v2');
    return (
        isFormV2EnabledForNonCopilotUsers ||
        isModalFormEnabledForCopilotUsers() ||
        isInlineFormEnabled()
    );
}

export function isInlineFormEnabled(): boolean {
    return isInlineFormEnabledForCopilotUsers() || isGlobalFeatureEnabled('cal-forms-v2-inline');
}

export function isModalFormEnabledForCopilotUsers(): boolean {
    return (
        isCopilotLicensedAndEnabledUser() && isGlobalFeatureEnabled('cal-forms-v2-copilot-modal')
    );
}

export function isInlineFormEnabledForCopilotUsers(): boolean {
    return (
        isInlineFormEnabledForCopilotStarterUsers() || isInlineFormEnabledForCopilotPremiumUsers()
    );
}

export function isInlineFormEnabledForCopilotPremiumUsers(): boolean {
    return (
        isCopilotLicensedAndEnabledUser() &&
        isGlobalFeatureEnabled('cal-forms-v2-copilot-inline-i1') &&
        isCopilotSidePaneFeatureEnabled()
    );
}

function isInlineFormEnabledForCopilotStarterUsers(): boolean {
    return (
        isCopilotStarterSkuAndEnabledUser() &&
        isGlobalFeatureEnabled('cal-forms-v2-copilot-inline-i1') &&
        isGlobalFeatureEnabled('cal-dab-in-forms-starter') &&
        isCopilotSidePaneFeatureEnabled()
    );
}

function isCopilotSidePaneFeatureEnabled() {
    return getHostHub() === 'teamshub'
        ? isGlobalFeatureEnabled('cal-teams-copilot')
        : isGlobalFeatureEnabled('mon-copilot-bizchat');
}
